module.exports = __webpack_public_path__ + "static/item4-7983c50d2f1799d821cb3f6b802885a7.svg";